import store from '@/store'
import { defaultCity } from '@/config/system.js'
import { Message, MessageBox } from 'element-ui'
import Bus from '@/api/bus'
import _ from 'lodash'

let indicatorMarker = null
// let pinActive=false
let url = require("@/assets/images/pin.png")

// mapObject 全局map实例
export const $location = {
  geoLocation(map) {
    return util.geolocation.getCurrentPosition(function (status, result) {
      if (status === 'complete') {
        util.geolocation.getCityInfo(function (status, result) {
          // if (status === 'complete' &&result.adcode !== defaultCity.adcode) {
          //   MessageBox.confirm('您当前未处于' + defaultCity.city + '，是否要切换到' + defaultCity.city + '？', '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'info'
          //   }).then((res) => {
          //     map.setCenter([defaultCity.longitude, defaultCity.latitude])
          //     map.setFitView()
          //   }).catch(() => {
          //     map.setCenter([...result.position])
          //   })
          // }
        })

        store.commit('setStartPos', {
          lng: result.position.lng,
          lat: result.position.lat
        })
        localStorage.removeItem("lat")
        localStorage.removeItem('lng')
        localStorage.setItem("lat", result.position.lat)
        localStorage.setItem("lng", result.position.lng)
        Bus.$emit('lat',result.position.lat)
        Bus.$emit('lng',result.position.lng)
        store.commit('setGeoLocation', [result.position.lng, result.position.lat])
        Message('定位获取成功')

      } else {
        // Message('未获取到定位，将定位到默认位置')
        map.setCenter([defaultCity.longitude, defaultCity.latitude])
        store.commit('setStartPos', {
          lng: defaultCity.longitude,
          lat: defaultCity.latitude
        })
        store.commit('setGeoLocation', [defaultCity.longitude, defaultCity.latitude])
        util.centerMarker = new AMap.Marker({
          map: map,
          content: '<img class="amap-geolocation-marker" src="https://a.amap.com/jsapi/static/image/plugin/point.png">',
          position: new AMap.LngLat(defaultCity.longitude, defaultCity.latitude) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
      }
    })
  },
  setCenter(centerPoint) {
    let { mapObject } = store.getters
    mapObject && mapObject.setCenter(centerPoint)
  },
  fitView() {
    let { mapObject } = store.getters
    mapObject && mapObject.setFitView()
  }
}
export const $marker = {
  createMarkers(data, isHideMarkerInfo) {
    const markerArr = []
    for (let i = 0; i < data.length; i++) {
      let item = data[i]
      if (!item.longitude || !item.latitude) continue
      markerArr.push(new AMap.Marker({
        offset: new AMap.Pixel(-20, -40),
        position: new AMap.LngLat(item.longitude, item.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        label: isHideMarkerInfo ? '' : {
          content: '<div class="marker-label" style="user-select: none;">' + item.name + '</div>',
          offset: new AMap.Pixel(0, -10), // 设置文本标注偏移量
          direction: 'top', // 设置文本标注方位

        },
        content: `<div class="map-marker" style="background:url(${url}) no-repeat center; color:white; background-size:70% 100%;">${i + 1}</div>`
        // content: `<div class="map-marker"><i class="marker-bg ri-map-pin-2-fill"></i><i class="marker-icon ${item.icon}"></i></div>` // 添加 Icon 图标 URL
      }))
    }
    return markerArr
  },
  createInfo(data) {
    const markerArr = []
    // let { mapObject } = store.getters;
    const len = data.length
    for (let i = 0; i < len; i++) {
      const infoWin = new AMap.InfoWindow({
        isCustom: true,
        offset: new AMap.Pixel(0, -48),
        content: ('<div class="map-info clearfix">' +
          '<div class="info" style="width: 130px; user-select: none;">' + data[i].name + '</div>' +
          '<div class="icon" onclick="goThere(' + JSON.stringify(data[i]).replace(/"/g, '&quot;') + ')"><i></i><span>到这儿去</span>' +
          '</div>' +
          '</div>')
      })
      markerArr.push(infoWin)
    }
    return markerArr
  },
  addMass(data) {
    let { mapObject } = store.getters;

    let style = [
      {
        // 政务服务大厅
        url: require("@/assets/images/type0.png"),
        anchor: new AMap.Pixel(6, 6),
        size: new AMap.Size(30, 33),
        zIndex: 3, // zIndex: 每种样式图标的叠加顺序，数字越大越靠前
      }, {
        // 专业大厅
        url: require("@/assets/images/type1.png"),
        anchor: new AMap.Pixel(6, 6),
        size: new AMap.Size(30, 33),
        zIndex: 2,
      }, {
        // 社区服务站
        url: require("@/assets/images/type2.png"),
        anchor: new AMap.Pixel(6, 6),
        size: new AMap.Size(30, 33),
        zIndex: 1,
      }, {
        // 自助终端
        url: require("@/assets/images/type3.png"),
        anchor: new AMap.Pixel(6, 6),
        size: new AMap.Size(30, 33),
        zIndex: 1,
      }];
    let massMarks = new AMap.MassMarks(data, {
      zooms: [3, 19],	 // 在指定地图缩放级别范围内展示海量点图层
      style: style, 	//多种样式对象的数组
      alwaysRender: false,
    });
    indicatorMarker = new AMap.Marker({
      content: ' ',
      map: mapObject,
      offset: new AMap.Pixel(-135, -75),
    });
    massMarks.on('click', (e) => {
      let { data } = e
      Bus.$emit('val', false)
      indicatorMarker.setPosition(data.lnglat);
      indicatorMarker.setContent(
        `<div class="map-info clearfix">
          <div class="info" style="width: 200px;">${data.name}</div>
          <div class="icon" style="width: 90px;" onclick="goThere(${JSON.stringify(data).replace(/"/g, '&quot;')})">
            <i></i><span>到这儿去</span>
          </div>
        </div>`)
      window.onselectMarker(data)
    });
    massMarks.setMap(mapObject)
  },
  addPlenty(data) {
    let { mapObject } = store.getters
    mapObject.add(data)
  },
  addOne(marker) {
    //code here
  },
  remove(marker) {
    //code here
  },
  removeAll() {
    //code here
  },
  active(data, dataList, markerList, infoList) {
    let { mapObject } = store.getters
    console.log('dataList',dataList)
    const dataIndex = _.findIndex(dataList, function (item) {
      if (data.code != undefined && data.code != '') {
        return item.code === data.code
      } else {
        return item.code === data
      }

    })
    let point = dataList[dataIndex];
    let marker = markerList[dataIndex]
    let info = infoList[dataIndex]
    let centerPoint = [data.longitude, data.latitude]
    // marker.setLabel({
    //   content: '' // 设置文本标注内容
    // })
    console.log('markerList',markerList)
    for (let i = 0; i < markerList.length; i++) {
      let marker = markerList[i]
      marker.setContent(`<div class="map-marker" style="display:"none"; background:url(${url}) no-repeat center; color:white; background-size:70% 100%;"></div>`)
    }
    marker.setContent(`<div class="map-marker" style="background:url(${url}) no-repeat center; color:white; background-size:70% 100%;">${dataIndex + 1}</div>`)
    info.open(
      mapObject,
      centerPoint
    )
    mapObject.setCenter(centerPoint)
    store.commit('setEndPos', {
      lng: data.longitude,
      lat: data.latitude
    })
  },
  hideInfo(dataList, markerList, infoList) {
    const len = dataList.length
    for (let j = 0; j < len; j++) {
      infoList[j].close()
      markerList[j].setLabel({
        content: '' // 设置文本标注内容
      })
      // markerList[j].setContent('<div class="map-marker"><i class="marker-bg ri-map-pin-2-fill"></i><i class="marker-icon ' + dataList[j].icon + '"></i></div>')
    }
  },
  normalize(dataList, markerList, infoList, isHideMarkerInfo) {
    const len = dataList.length
    for (let j = 0; j < len; j++) {
      infoList[j].close()
      markerList[j].setLabel(
        isHideMarkerInfo
          ?
          { content: '' }
          : // 设置文本标注内容
          {
            content: '<div class="marker-label" style="user-select: none;">' + dataList[j].name + '</div>',
            offset: new AMap.Pixel(0, -10), // 设置文本标注偏移量
            direction: 'top' // 设置文本标注方位
          }
      )
      markerList[j].setContent(`<div class="map-marker" style="background:url(${url}) no-repeat center; color:white; background-size:70% 100%;">${j + 1}</div>`)
    }
  }
}
export const $route = {
  /**
   * 输入提示后查询
  */
  placeSearch(tipinput, selectFn) {
    let { mapObject } = store.getters
    return new Promise(function (resolve) {
      //输入提示
      var autoOptions = {
        input: tipinput
      };
      AMap.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete'], function () {
        var auto = new AMap.AutoComplete(autoOptions);
        var placeSearch = new AMap.PlaceSearch({
          map: mapObject,
          city: defaultCity.city
        });  //构造地点查询类
        auto.on("select", selectFn);//注册监听，当选中某条记录时会触发
        var ret = { placeSearch: placeSearch, selectFn: selectFn }
        resolve(ret);
      });
    })
  },
  remove() {

  },
  removeAll() {
    let { driving, transfer, walking } = store.getters
    if (driving) {
      driving.clear()
    }
    if (transfer) {
      transfer.clear()
    }
    if (walking) {
      walking.clear()
    }

    let { isFitView } = store.getters
    if (isFitView) $location.fitView()
  },
  draw(code, startLngLat, endLngLat) {
    let { driving, transfer, walking, mapObject } = store.getters
    console.log('startLngLat----', startLngLat,endLngLat)
    if (driving) {
      driving.clear()
    }
    if (transfer) {
      transfer.clear()
    }
    if (walking) {
      walking.clear()
    }

    if (code === '1') {
      // debugger
      mapObject.plugin('AMap.Driving', function () {

        driving = new AMap.Driving({
          map: mapObject,
          // panel 指定将结构化的路线详情数据显示的对应的DOM上，传入值需是DOM的ID
          panel: 'map-panel',
          // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
          policy: AMap.DrivingPolicy.LEAST_TIME
        })
        driving.search(startLngLat, endLngLat, function (status, result) {
          // debugger
          console.log('startLngLat', startLngLat,endLngLat)
          // 未出错时，result即是对应的路线规划方案
          console.log(status, result)
        })
      })
      store.commit('setDriving', driving)
    }
    if (code === '2') {
      mapObject.plugin('AMap.Transfer', function () {
        transfer = new AMap.Transfer({
          city: store.state.currentCity,
          map: mapObject,
          // panel 指定将结构化的路线详情数据显示的对应的DOM上，传入值需是DOM的ID
          panel: 'map-panel',
          // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
          policy: AMap.TransferPolicy.LEAST_TIME
        })
        transfer.search(startLngLat, endLngLat, function (status, result) {
          // 未出错时，result即是对应的路线规划方案
          console.log(status, result)
        })
      })
      store.commit('setTransfer', transfer)
    }
    if (code === '3') {
      mapObject.plugin('AMap.Walking', function () {
        walking = new AMap.Walking({
          map: mapObject,
          // panel 指定将结构化的路线详情数据显示的对应的DOM上，传入值需是DOM的ID
          panel: 'map-panel'
        })
        walking.search(startLngLat, endLngLat, function (status, result) {
          // 未出错时，result即是对应的路线规划方案
          console.log(status, result)
        })
      })
      store.commit('setWalking', walking)
    }
  }
}

const util = {
  geolocation: null,
  initMap(id = 'map-container') {
    let map = new AMap.Map(id, {
      zoom: 12, // 级别
      viewMode: '3D', // 地图模式
      resizeEnable: true
    })
    // var circleEditor = new AMap.CircleEditor(map, circle)
    map.on('zoomchange', (e) => {
      let zoom = map.getZoom()
      store.commit('setIsHideMarkerInfo', zoom <= 13)
    })
    const toolBar = new AMap.ToolBar({
      position: 'RB',
      offset: [16, 64]
    })
    map.addControl(toolBar)
    // 定位到当前位置
    map.plugin('AMap.Geolocation', function () {
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 6000, // 超过10秒后停止定位，默认：无穷大
        maximumAge: 0, // 定位结果缓存0毫秒，默认：0
        convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        showButton: true, // 显示定位按钮，默认：true
        buttonPosition: 'RB', // 定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: false // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      })
      util.geolocation = geolocation
      map.addControl(geolocation)
      util.$location.geoLocation(map)
    })
    store.commit('setMapObject', map)
  },
  getType() {

  },
  getMap() {
    let { mapObject } = store.getters
    return mapObject
  },
  clear() {
    let { mapObject } = store.getters
    mapObject.clear()
  },
  $location,
  $marker,
  $route,
}

export default util;
